import { printf, toText, endsWith, substring } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";

function tryRemoveLeft(toRemove, input) {
    if (input.indexOf(toRemove) === 0) {
        return substring(input, toRemove.length);
    }
    else {
        return input;
    }
}

function tryRemoveRight(toRemove, input) {
    if (endsWith(input, toRemove)) {
        return substring(input, 0, input.length - toRemove.length);
    }
    else {
        return input;
    }
}

function normalizeTypAndMethod(t, m) {
    return [tryRemoveRight("service", tryRemoveLeft("i", t.toLocaleLowerCase())), m.toLocaleLowerCase()];
}

export function routeBuilder(t, m) {
    const patternInput = normalizeTypAndMethod(t, m);
    return toText(printf("/api/%s/%s"))(patternInput[0])(patternInput[1]);
}

export function routeBuilderPatienten(t, m) {
    const patternInput = normalizeTypAndMethod(t, m);
    return toText(printf("/api/patienten/%s/%s"))(patternInput[0])(patternInput[1]);
}

//# sourceMappingURL=Routing.fs.js.map
